function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useEffect, useMemo, useState } from 'react';
import { Box, Flex, icons, Stack } from '@tapresearch/ui/components';
import { useQualificationAnswerLabels, useQuestionTapAnswersList, useTapQuestionCrossTabResult, useTapQuestionResult } from '../../../api';
import { DotLoader, GraphToggleSwitch, QuestionResultWrapper } from '../../common';
import useAsset from '../../hook/useAsset';
import { FreeTextAnswersList, RankingQuestionTable, ResultsTableView, StackedBarChart } from './charts';
import { GroupAnswersSwitch } from './GroupAnswersSwitch';
import { HideEmptySwitch } from './HideEmptySwitch';
import { useCrossTabBarData } from './hooks/useCrossTabBarData';
import { NoResultsFound } from './NoResultsFound';
import { OtherAnswersAccordion } from './OtherAnswersAccordion';
import { QuestionItemComparisons } from './QuestionItemComparisons';
var GROUPABLE_MC_ANSWERS_COUNT = 8;
export var SurveyQuestionItemResults = function(param) {
    var tapQuestion = param.tapQuestion, countryId = param.countryId, languageId = param.languageId, comparisonQuestions = param.comparisonQuestions, filters = param.filters, campaignResultIdentifier = param.campaignResultIdentifier;
    var _results_attributes_results, _results_attributes, _results_attributes_results1, _results_attributes1, _results_attributes_results2, _results_attributes2, _results_attributes_results3, _results_attributes3;
    var asset = useAsset();
    var isRanking = tapQuestion.tap_answer_type === asset.constants.TAP_ANSWER_TYPE_RANKING;
    var isFreeText = tapQuestion.tap_answer_type === asset.constants.TAP_ANSWER_TYPE_FREE_TEXT;
    var isMessage = tapQuestion.tap_answer_type === asset.constants.TAP_ANSWER_TYPE_MESSAGE;
    var isRating = tapQuestion.tap_answer_type === asset.constants.TAP_ANSWER_TYPE_SCALE_RANGE;
    var isChartable = ![
        asset.constants.TAP_ANSWER_TYPE_FREE_TEXT,
        asset.constants.TAP_ANSWER_TYPE_MESSAGE
    ].includes(tapQuestion.tap_answer_type);
    var _useState = _sliced_to_array(useState(), 2), crossTabQuestionId = _useState[0], setCrossTabQuestionId = _useState[1];
    var _useState1 = _sliced_to_array(useState(true), 2), usePercentage = _useState1[0], setUsePercentage = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), isTableView = _useState2[0], setIsTableView = _useState2[1];
    var _useState3 = _sliced_to_array(useState(null), 2), totalRespondents = _useState3[0], setTotalRespondents = _useState3[1];
    var _useState4 = _sliced_to_array(useState(false), 2), isHidingEmptyCrossTab = _useState4[0], setIsHidingEmptyCrossTab = _useState4[1];
    var _useState5 = _sliced_to_array(useState(false), 2), isSwitching = _useState5[0], setIsSwitching = _useState5[1];
    var _useState6 = _sliced_to_array(useState(false), 2), isGroupedAnswers = _useState6[0], setIsGroupedAnswers = _useState6[1];
    var isDemographicCrossTab = useMemo(function() {
        return !!crossTabQuestionId && !crossTabQuestionId.startsWith('tq_');
    }, [
        crossTabQuestionId
    ]);
    var isTapQuestionCrossTab = useMemo(function() {
        return !!crossTabQuestionId && crossTabQuestionId.startsWith('tq_');
    }, [
        crossTabQuestionId
    ]);
    var _useTapQuestionResult = useTapQuestionResult({
        tapQuestionIdentifier: !crossTabQuestionId && tapQuestion.identifier,
        filters: filters,
        groupAnswers: isGroupedAnswers,
        campaignResultIdentifier: campaignResultIdentifier
    }), results = _useTapQuestionResult.data, isResultsLoading = _useTapQuestionResult.isLoading;
    var _useTapQuestionCrossTabResult = useTapQuestionCrossTabResult({
        tapQuestionIdentifier: crossTabQuestionId && tapQuestion.identifier,
        filters: filters,
        crossTabQuestionId: crossTabQuestionId,
        groupAnswers: isGroupedAnswers,
        campaignResultIdentifier: campaignResultIdentifier
    }), crossTabResults = _useTapQuestionCrossTabResult.data, isCrossTabLoading = _useTapQuestionCrossTabResult.isLoading;
    var _useQuestionTapAnswersList = useQuestionTapAnswersList(tapQuestion.identifier, campaignResultIdentifier), tapAnswersResponse = _useQuestionTapAnswersList.data, isTapAnswersLoading = _useQuestionTapAnswersList.isLoading;
    var tapAnswers = useMemo(function() {
        var _crossTabResults_attributes_results, _crossTabResults_attributes, _results_attributes_results, _results_attributes;
        if (!isGroupedAnswers && (!tapAnswersResponse || !!tapAnswersResponse.length || !isRating)) {
            return tapAnswersResponse;
        }
        var formatAsTapAnswer = function(id, tapQuestionId) {
            return {
                id: id,
                attributes: {
                    id: id,
                    option_text: id,
                    tap_question_id: tapQuestionId
                }
            };
        };
        if (!isGroupedAnswers && isRating) {
            return _to_consumable_array(Array(tapQuestion.scale_range)).map(function(_, i) {
                return formatAsTapAnswer("".concat(i + 1), tapQuestion.id);
            });
        }
        // Grouped answers - get labels from the result sets
        var hasResultsLoaded = !!crossTabQuestionId ? crossTabResults : results;
        if (!hasResultsLoaded) return null;
        var labelData = !!crossTabQuestionId ? (crossTabResults === null || crossTabResults === void 0 ? void 0 : (_crossTabResults_attributes = crossTabResults.attributes) === null || _crossTabResults_attributes === void 0 ? void 0 : (_crossTabResults_attributes_results = _crossTabResults_attributes.results) === null || _crossTabResults_attributes_results === void 0 ? void 0 : _crossTabResults_attributes_results.labels) || null : Object.keys((results === null || results === void 0 ? void 0 : (_results_attributes = results.attributes) === null || _results_attributes === void 0 ? void 0 : (_results_attributes_results = _results_attributes.results) === null || _results_attributes_results === void 0 ? void 0 : _results_attributes_results.answers) || {});
        return labelData === null || labelData === void 0 ? void 0 : labelData.map(function(groupLabel) {
            return formatAsTapAnswer(groupLabel, tapQuestion.id);
        });
    }, [
        isRating,
        tapAnswersResponse,
        tapQuestion,
        results,
        crossTabQuestionId,
        crossTabResults,
        isGroupedAnswers
    ]);
    var crossTabAnswerLabels = useMemo(function() {
        if (isTapQuestionCrossTab) {
            var crossTabQuestion = comparisonQuestions[1][crossTabQuestionId];
            return crossTabQuestion.answers.reduce(function(acc, answer) {
                return _object_spread_props(_object_spread({}, acc), _define_property({}, answer.id.toString(), answer.text));
            }, {});
        }
    }, [
        comparisonQuestions,
        crossTabQuestionId,
        isTapQuestionCrossTab
    ]);
    var _useQualificationAnswerLabels = useQualificationAnswerLabels({
        questionId: !!isDemographicCrossTab && crossTabQuestionId,
        countryId: countryId,
        languageId: languageId,
        campaignResultIdentifier: campaignResultIdentifier
    }), qualificationLabels = _useQualificationAnswerLabels.data, isQualificationLabelsLoading = _useQualificationAnswerLabels.isLoading;
    var crossTabLabelsHash = isDemographicCrossTab ? qualificationLabels : crossTabAnswerLabels;
    var standardBarData = useMemo(function() {
        var _results_attributes_results, _results_attributes;
        return Object.entries((results === null || results === void 0 ? void 0 : (_results_attributes = results.attributes) === null || _results_attributes === void 0 ? void 0 : (_results_attributes_results = _results_attributes.results) === null || _results_attributes_results === void 0 ? void 0 : _results_attributes_results.answers) || {}).map(function(param) {
            var _param = _sliced_to_array(param, 2), answerId = _param[0], answerValues = _param[1];
            var _obj;
            return _obj = {
                answer_id: answerId
            }, _define_property(_obj, answerId.toString(), (answerValues === null || answerValues === void 0 ? void 0 : answerValues.percentage) || 0), _define_property(_obj, answerId.toString() + '_total', answerValues === null || answerValues === void 0 ? void 0 : answerValues.total), _obj;
        });
    }, [
        results
    ]);
    var crossTabBarData = useCrossTabBarData({
        crossTabLabelsHash: crossTabLabelsHash,
        crossTabResults: crossTabResults,
        isHidingEmptyCrossTab: isHidingEmptyCrossTab
    });
    var otherAnswers = results === null || results === void 0 ? void 0 : (_results_attributes = results.attributes) === null || _results_attributes === void 0 ? void 0 : (_results_attributes_results = _results_attributes.results) === null || _results_attributes_results === void 0 ? void 0 : _results_attributes_results.other_answers;
    var freeTextAnswers = (results === null || results === void 0 ? void 0 : (_results_attributes1 = results.attributes) === null || _results_attributes1 === void 0 ? void 0 : (_results_attributes_results1 = _results_attributes1.results) === null || _results_attributes_results1 === void 0 ? void 0 : _results_attributes_results1.free_text_answers) || [];
    var barData = !!crossTabQuestionId ? crossTabBarData : standardBarData;
    var hasLabels = !!tapAnswers && (!crossTabQuestionId || !!crossTabLabelsHash);
    var numRows = isRating ? Object.keys(barData).length : hasLabels && (!!crossTabQuestionId ? Object.keys(crossTabBarData).length : tapAnswers.length) || 0;
    var barHeight = 32;
    var barGap = 10;
    var chartHeight = numRows * barHeight + (numRows - 1) * barGap + 100;
    useEffect(function() {
        if (!crossTabQuestionId && results) {
            var _results_attributes_results, _results_attributes;
            setTotalRespondents((results === null || results === void 0 ? void 0 : (_results_attributes = results.attributes) === null || _results_attributes === void 0 ? void 0 : (_results_attributes_results = _results_attributes.results) === null || _results_attributes_results === void 0 ? void 0 : _results_attributes_results.total_respondents) || 0);
        }
    }, [
        crossTabQuestionId,
        results
    ]);
    useEffect(function() {
        setIsSwitching(true);
    }, [
        isHidingEmptyCrossTab,
        isGroupedAnswers,
        crossTabQuestionId
    ]);
    useEffect(function() {
        if (isSwitching) {
            setTimeout(function() {
                setIsSwitching(false);
            }, 300);
        }
    }, [
        isSwitching
    ]);
    var isAnyLoading = isResultsLoading || isCrossTabLoading || isTapAnswersLoading || isSwitching || isQualificationLabelsLoading;
    var noResponses = (results === null || results === void 0 ? void 0 : (_results_attributes2 = results.attributes) === null || _results_attributes2 === void 0 ? void 0 : (_results_attributes_results2 = _results_attributes2.results) === null || _results_attributes_results2 === void 0 ? void 0 : _results_attributes_results2.total_respondents) === 0 || totalRespondents === 0;
    var graphPercentToggleSwitch = useMemo(function() {
        return /*#__PURE__*/ React.createElement(GraphToggleSwitch, {
            leftItem: {
                icon: icons.fi.Percent,
                label: 'Graph by percentages',
                callback: function() {
                    return setUsePercentage(true);
                }
            },
            rightItem: {
                icon: icons.fi.Hash,
                label: 'Graph by respondent totals',
                callback: function() {
                    return setUsePercentage(false);
                }
            },
            selectedItem: usePercentage ? 'left' : 'right'
        });
    }, [
        usePercentage
    ]);
    var graphTableToggleSwitch = useMemo(function() {
        return /*#__PURE__*/ React.createElement(GraphToggleSwitch, {
            leftItem: {
                icon: icons.fi.BarChart2,
                label: 'Show chart view',
                callback: function() {
                    return setIsTableView(false);
                }
            },
            rightItem: {
                icon: icons.io4.MdGrid,
                label: 'Show table view',
                callback: function() {
                    return setIsTableView(true);
                }
            },
            selectedItem: !isTableView ? 'left' : 'right'
        });
    }, [
        isTableView
    ]);
    var hideEmptySwitch = useMemo(function() {
        return /*#__PURE__*/ React.createElement(HideEmptySwitch, {
            isHiding: isHidingEmptyCrossTab,
            isSwitching: isSwitching,
            setIsHiding: setIsHidingEmptyCrossTab
        });
    }, [
        isHidingEmptyCrossTab,
        isSwitching
    ]);
    var canGroupAnswers = isChartable && !isRanking;
    var groupAnswersSwitch = useMemo(function() {
        return canGroupAnswers && /*#__PURE__*/ React.createElement(GroupAnswersSwitch, _object_spread({
            isGrouped: isGroupedAnswers,
            isSwitching: isSwitching,
            isDisabled: !isRating && !(((tapAnswersResponse === null || tapAnswersResponse === void 0 ? void 0 : tapAnswersResponse.length) || 0) > GROUPABLE_MC_ANSWERS_COUNT),
            setIsGrouped: setIsGroupedAnswers,
            label: isRating ? 'Group answers:' : 'Simplify data:'
        }, !isRating && {
            tooltipText: "This toggle simplifies your data by combining any answers beyond ".concat(GROUPABLE_MC_ANSWERS_COUNT, " into a single category. Turn off toggle to view answers/data in full.")
        }));
    }, [
        isGroupedAnswers,
        isRating,
        tapAnswersResponse,
        canGroupAnswers,
        isSwitching
    ]);
    if (isMessage) return /*#__PURE__*/ React.createElement(QuestionResultWrapper, {
        tapQuestion: tapQuestion
    });
    return /*#__PURE__*/ React.createElement(QuestionResultWrapper, {
        tapQuestion: tapQuestion,
        totalRespondents: totalRespondents
    }, /*#__PURE__*/ React.createElement(Box, {
        w: {
            base: 'full',
            md: 'calc(100% - 130px)'
        },
        ml: {
            base: 0,
            md: '65px'
        },
        px: {
            base: 4,
            md: 0
        }
    }, isChartable && !isRanking && !!totalRespondents && /*#__PURE__*/ React.createElement(Flex, {
        mt: 6,
        align: "flex-start",
        flexWrap: {
            base: 'wrap',
            md: 'nowrap'
        }
    }, /*#__PURE__*/ React.createElement(QuestionItemComparisons, {
        compareState: [
            crossTabQuestionId,
            setCrossTabQuestionId
        ],
        comparisonQuestions: comparisonQuestions,
        tapQuestionId: tapQuestion.id.toString()
    }), /*#__PURE__*/ React.createElement(ChartControls, {
        isCrossTab: !!crossTabQuestionId,
        graphTableToggleSwitch: graphTableToggleSwitch,
        graphPercentToggleSwitch: graphPercentToggleSwitch,
        hideEmptySwitch: hideEmptySwitch,
        groupAnswersSwitch: groupAnswersSwitch
    })), noResponses && !isAnyLoading ? /*#__PURE__*/ React.createElement(NoResultsFound, null) : /*#__PURE__*/ React.createElement(Flex, {
        justify: "space-between",
        direction: {
            base: 'column',
            md: 'row'
        }
    }, isAnyLoading ? /*#__PURE__*/ React.createElement(Flex, {
        justify: "center",
        align: "center",
        w: "full",
        h: "400px"
    }, /*#__PURE__*/ React.createElement(DotLoader, {
        h: 10,
        dotSize: "20px"
    })) : /*#__PURE__*/ React.createElement(React.Fragment, null, isFreeText ? /*#__PURE__*/ React.createElement(FreeTextAnswersList, {
        answers: freeTextAnswers
    }) : barData && hasLabels && /*#__PURE__*/ React.createElement(Box, _object_spread({
        ml: "2px",
        w: {
            base: '100%',
            md: !!crossTabQuestionId ? 'calc(100% - 280px)' : '100%'
        }
    }, !!crossTabQuestionId && {
        mt: {
            base: 0,
            md: '-60px'
        }
    }), /*#__PURE__*/ React.createElement(Box, {
        w: "full",
        height: isRanking || isTableView ? 'auto' : chartHeight
    }, isRanking && /*#__PURE__*/ React.createElement(Flex, {
        justify: "space-between",
        w: "full",
        px: {
            base: 4,
            md: 0
        },
        mt: {
            base: 6,
            md: 0
        },
        flexWrap: {
            base: 'wrap',
            md: 'nowrap'
        },
        flexDirection: {
            base: 'column-reverse',
            md: 'row'
        }
    }, /*#__PURE__*/ React.createElement(RankingQuestionTable, {
        usePercentage: usePercentage,
        tapAnswers: tapAnswers,
        results: results === null || results === void 0 ? void 0 : (_results_attributes3 = results.attributes) === null || _results_attributes3 === void 0 ? void 0 : (_results_attributes_results3 = _results_attributes3.results) === null || _results_attributes_results3 === void 0 ? void 0 : _results_attributes_results3.answers
    }), /*#__PURE__*/ React.createElement(Flex, {
        w: {
            base: 'full',
            md: '150px'
        },
        justify: "flex-end"
    }, graphPercentToggleSwitch)), [
        asset.constants.TAP_ANSWER_TYPE_MULTIPLE_CHOICE,
        asset.constants.TAP_ANSWER_TYPE_IMAGE_CHOICE,
        asset.constants.TAP_ANSWER_TYPE_SCALE_RANGE
    ].includes(tapQuestion.tap_answer_type) && /*#__PURE__*/ React.createElement(React.Fragment, null, isTableView ? /*#__PURE__*/ React.createElement(ResultsTableView, _object_spread({
        tableData: barData,
        tapAnswers: tapAnswers,
        usePercentage: usePercentage
    }, !!crossTabQuestionId && {
        crossTabLabels: crossTabLabelsHash
    })) : /*#__PURE__*/ React.createElement(StackedBarChart, {
        isCrossTab: !!crossTabQuestionId,
        usePercentage: usePercentage,
        tapAnswers: tapAnswers,
        isImageChoice: tapQuestion.tap_answer_type === asset.constants.TAP_ANSWER_TYPE_IMAGE_CHOICE,
        data: barData,
        legendContainerId: "question-".concat(tapQuestion.id, "-legend-container")
    }))), !!(otherAnswers === null || otherAnswers === void 0 ? void 0 : otherAnswers.length) && /*#__PURE__*/ React.createElement(OtherAnswersAccordion, {
        otherAnswers: otherAnswers
    }))), !!crossTabQuestionId && /*#__PURE__*/ React.createElement(Box, {
        w: "220px",
        mt: 6,
        pb: 16,
        h: "100%",
        ml: {
            base: 4,
            md: 0
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        "data-testid": "chart-legend-container",
        id: "question-".concat(tapQuestion.id, "-legend-container")
    })))));
};
var ChartControls = function(param) {
    var isCrossTab = param.isCrossTab, graphTableToggleSwitch = param.graphTableToggleSwitch, graphPercentToggleSwitch = param.graphPercentToggleSwitch, hideEmptySwitch = param.hideEmptySwitch, groupAnswersSwitch = param.groupAnswersSwitch;
    return /*#__PURE__*/ React.createElement(Stack, _object_spread({
        w: {
            base: '180px',
            md: '280px'
        },
        alignItems: "flex-end",
        direction: {
            base: 'row',
            md: 'column'
        },
        spacing: 4,
        ml: {
            base: 2,
            md: 12
        },
        mt: {
            base: 5,
            md: 0
        },
        flexGrow: {
            base: 1,
            md: 0
        }
    }, isCrossTab && {
        borderBottom: '1px solid',
        borderColor: 'gray.200',
        pb: 4
    }), /*#__PURE__*/ React.createElement(Stack, {
        spacing: 4,
        flexGrow: 1,
        direction: "row",
        justify: {
            base: 'flex-start',
            md: 'space-between'
        }
    }, graphTableToggleSwitch, isCrossTab && graphPercentToggleSwitch), groupAnswersSwitch, isCrossTab && hideEmptySwitch);
};
